export default "P {\n  text-align: center; }\n\nh2 {\n  text-align: center; }\n"